import { Box, Typography } from "@mui/material";
import ServicesHero from "./Services/Services";
import { styled } from "@mui/material/styles";

const MainContainer = styled(Box)(({ theme }) => ({
 minHeight:"80vh",
  background: "#000",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(4),
  position: "relative",
  overflow: "hidden",

  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    right: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
   // backdropFilter: "blur(500px)",
    zIndex: 0,
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%", // Set to 95% width
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export default function HeroServices({ title, subTitle }) {
  return (
    <MainContainer>
      <ContentContainer>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "800px", // Added max-width for better content control
            textAlign: "center",
            py: 4,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "24px", sm: "32px", md: "40px" },
              fontWeight: 700,
              mb: 2,
              textAlign: "center",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: "#8C8CC2",
              fontSize: { xs: "14px", md: "18px" },
              lineHeight: 1.8,
              textAlign: "center",
              marginTop: 2,
            }}
          >
            {subTitle}
          </Typography>
        </Box>

        <ServicesHero />
      </ContentContainer>
    </MainContainer>
  );
}
